<template>
    <div class="min-h-screen bg-gray-100">
      <!-- Vista para usuarios autenticados -->
      <div v-if="user">
        <SidebarMenu
          :user="user"
          :isMenuOpen="isMenuOpen"
          @toggle-menu="toggleMenu"
          @close-menu="closeMenu"
          @logout="logout"
        />
        
        <div class="md:ml-64">
          <main class="p-4">
            <div class="p-6">
              <div class="text-center">
                <!-- Icono de error -->
                <div class="mb-8">
                  <div class="inline-flex items-center justify-center w-24 h-24 bg-red-100 rounded-full mb-4">
                    <svg class="w-12 h-12 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.082 16.5c-.77.833.192 2.5 1.732 2.5z"></path>
                    </svg>
                  </div>
                  <h1 class="text-6xl font-bold text-gray-800 mb-2">404</h1>
                  <h2 class="text-2xl font-semibold text-gray-700 mb-4">Página no encontrada</h2>
                </div>
  
                <!-- Mensaje de error -->
                <div class="bg-white rounded-lg shadow-lg p-6 mb-6 max-w-2xl mx-auto">
                  <p class="text-gray-600 mb-4">
                    Lo sentimos, la página que estás buscando no existe o ha sido movida.
                  </p>
                  <div class="text-sm text-gray-500 bg-gray-50 rounded p-3">
                    <strong>URL solicitada:</strong> {{ $route.fullPath }}
                  </div>
                </div>
  
                <!-- Botón de navegación -->
                <button
                  @click="goToDashboard"
                  class="bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-6 rounded-lg transition-colors duration-200 flex items-center justify-center space-x-2 mx-auto"
                >
                  <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2H5a2 2 0 00-2-2z"></path>
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 5a2 2 0 012-2h2a2 2 0 012 2v2H8V5z"></path>
                  </svg>
                  <span>Ir al Inicio</span>
                </button>
              </div>
            </div>
          </main>
        </div>
      </div>
  
      <!-- Vista para usuarios NO autenticados -->
      <div v-else class="min-h-screen">
        <header class="bg-gray-100">
          <div class="max-w-4xl mx-auto px-4 py-6">
            <div class="flex justify-between items-center">
              <div class="flex items-center space-x-3">
                <div class="w-10 h-10 bg-blue-500 rounded-lg flex items-center justify-center">
                  <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.031 9-11.622 0-1.042-.133-2.052-.382-3.016z"></path>
                  </svg>
                </div>
                <h1 class="text-2xl font-bold text-gray-800">Servicios del Atlántico</h1>
              </div>
              <button
                @click="goToLogin"
                class="text-white px-4 py-2 bg-blue-500 text-white rounded-lg shadow hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <span>Iniciar Sesión</span>
              </button>
            </div>
          </div>
        </header>
  
        <main class="max-w-4xl mx-auto px-4 py-8">
          <div class="bg-white rounded-lg shadow-lg p-6">
            <div class="text-center">
              <!-- Icono de error -->
              <div class="mb-8">
                <div class="inline-flex items-center justify-center w-24 h-24 bg-red-100 rounded-full mb-4">
                  <svg class="w-12 h-12 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.082 16.5c-.77.833.192 2.5 1.732 2.5z"></path>
                  </svg>
                </div>
                <h1 class="text-6xl font-bold text-gray-800 mb-2">404</h1>
                <h2 class="text-2xl font-semibold text-gray-700 mb-4">Página no encontrada</h2>
              </div>
  
              <!-- Mensaje de error -->
              <div class="mb-6">
                <p class="text-gray-600 mb-4">
                  Lo sentimos, la página que estás buscando no existe o ha sido movida.
                </p>
                <div class="text-sm text-gray-500 rounded p-3">
                  <strong>URL solicitada:</strong> {{ $route.fullPath }}
                </div>
              </div>
  
              <!-- Botón de navegación -->
              <button
                @click="goToLogin"
                class="bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-6 rounded-lg transition-colors duration-200 flex items-center justify-center space-x-2 mx-auto"
              >
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"></path>
                </svg>
                <span>Iniciar Sesión</span>
              </button>
            </div>
          </div>
        </main>
  
        <!-- Footer -->
        <footer class="mt-12">
          <div class="max-w-4xl mx-auto px-4 py-6">
            <div class="flex flex-col md:flex-row justify-between items-center">
              <div class="flex space-x-6 mt-4 md:mt-0">
                <a href="/terminos-del-servicio" class="text-gray-600 hover:text-gray-900 text-sm transition-colors">
                  Términos del Servicio
                </a>
                <a href="/politica-de-privacidad" class="text-gray-600 hover:text-gray-900 text-sm transition-colors">
                  Política de Privacidad
                </a>
              </div>
            </div>
          </div>
        </footer>
      </div>
  
      <!-- Loading state -->
      <div v-if="loading" class="min-h-screen flex items-center justify-center bg-gray-100">
        <div class="text-center">
          <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mx-auto mb-4"></div>
          <p class="text-gray-600">Cargando...</p>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  import SidebarMenu from '@/components/SidebarMenu.vue';
  
  export default {
    name: 'NotFoundPage',
    components: {
      SidebarMenu,
    },
    data() {
      return {
        user: null,
        isMenuOpen: false,
        loading: true,
        error: null,
      };
    },
    async created() {
      await this.checkAuthStatus();
    },
    methods: {
      async checkAuthStatus() {
        try {
          // Intentar obtener el usuario autenticado
          const response = await axios.get('/me');
          this.user = response.data.user;
          this.loading = false;
        } catch (error) {
          this.user = null;
          this.loading = false;
        }
      },
      goToLogin() {
        this.$router.push('/login');
      },
      goToDashboard() {
        this.$router.push('/inicio');
      },
      toggleMenu() {
        this.isMenuOpen = !this.isMenuOpen;
      },
      closeMenu() {
        this.isMenuOpen = false;
      },
      async logout() {
        try {
          // Obtener nuevo token CSRF
          await axios.get('/sanctum/csrf-cookie');
  
          // Esperar un momento para asegurar que la cookie se haya establecido
          await new Promise(resolve => setTimeout(resolve, 100));
  
          // Realizar la petición de logout
          const response = await axios.post('/logout', {}, {
            withCredentials: true,
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            }
          });
          
          console.log(response);
          
          // Limpiar cookies locales
          document.cookie.split(";").forEach(function(c) { 
            document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
          });
          
          // Redirigir al login
          this.$router.push('/login');
        } catch (error) {
          console.error('Error al cerrar sesión:', error.response?.data || error);
        }
      }
    }
  };
  </script>